var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-center"},[_c('app-icon',{attrs:{"color":_vm.color,"icon":_vm.icon,"size":"48"}}),_c('app-text',{staticClass:"text-center",attrs:{"size":"small"}},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }